import React from 'react';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaPaperPlane } from 'react-icons/fa';
import { SiX, } from 'react-icons/si';  // New "X" (Twitter) logo
import { useNavigate } from 'react-router-dom';



const Footerpage =() =>{
    const navigate = useNavigate()
     return (
        <div className="footer">
            <div className="">
                <div className="row footer-content">

                    <div className="col-md-4 col-sm-4 col-xs-12">
                        <div className="single_footer single_footer_address">
                            <h4>Page Link</h4>
                            <ul>
                                <li><a href="/About-Us" >About Us</a></li>
                                {/* <li><a href="#">Our Projects</a></li> */}
                                <li><a href="/Career">Career</a></li>
                                <li><a href="/Blog">Blog</a></li>
                                 <li><a href="/Contact-us">Contact Us</a></li>
                            </ul>

                        </div>
                    </div>
                     <div className="col-lg-4 col-sm-4 col-xs-12">
                        <div className="single_footer">
                            <h4>Services</h4>
                            <ul>
                                <li><a href="/technology-developmen-services" className="underline-hover">Technology Development Services</a></li>
                                <li><a href="/data-analytics-services" className="underline-hover" >Data &amp; Analytics Services</a></li>
                                <li><a href="/next-genTesting-services" className="underline-hover" onClick={() => navigate('')}>Next Gen Testing Services</a></li>
                                <li><a href="/aiml-services" className="underline-hover" onClick={() => navigate('')}>AI/ML Services</a></li>
                                <li><a href="/mobile-app-devlopment-services" className="underline-hover" onClick={() => navigate('')}>Enterprise Mobile App Development</a></li>
                                <li><a href="sales-force-competencies-services" className="underline-hover" onClick={() => navigate('')}>Salesforce Competencies</a></li>
                            <li><a href="/power-platform-services" className="underline-hover" onClick={() => navigate('')}>Microsoft Power Platform Services</a></li>               
                            </ul>
                        </div>
                    </div>

                    <div className="col-md-4 col-sm-4 col-xs-12">
                        <div className="single_footer single_footer_address">
                            <h4>Subscribe today</h4>
                            <div className="signup_form">
                                <form className="subscribe">
                                    <input type="text" className="subscribe__input" placeholder="Enter Email Address" />
                                    <button type="button" className="subscribe__btn">
                                        <FaPaperPlane />
                                    </button>
                                </form>
                            </div>
                        </div>

                        <div className="social_profile">
                            <ul>
                                <li><a href="https://www.facebook.com/share/o9V38G7km7WX4sqg/?mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer"><FaFacebook /></a></li>
                                <li><a href="https://x.com/Pravisht5" target="_blank" rel="noopener noreferrer"><SiX /></a></li>
                                <li><a href="https://in.linkedin.com/company/pravishtdigital" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a></li>
                                <li><a href="https://www.instagram.com/pravisht_digital?igsh=MXFycGlmMHN2bno2ag==" target="_blank" rel="noopener noreferrer"><FaInstagram /></a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row"> 
                    <div className="col-lg-12 col-sm-12 col-xs-12 footer-copyright">
                        <div>
                        <p className="copyright">
                            © 2025 Copyright. All rights reserved.
                        </p>
                        </div>
                        <div className='footer-links'>
                            <a href="#">Privacy Policy</a>
                            <a href="#">Terms of Service</a>
                            <a href="#">Cookie Policy</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footerpage;